<template>
  <div class="layui-card-body">
      <span style="display:inline-block;float:right;cursor:pointer" @click="readAll()">全部已读
        <span v-show="msgNum > 0">{{'(' + msgNum + ')'}}</span>
      </span>
      <div class="layui-tab layui-tab-brief" style="height: 100%;">
          <ul class="layui-tab-title" style="position: inherit">
              <li
                v-for="item in list"
                :key="item.value"
                :class="item.active ? 'layui-this' : '' "
                @click="loadTable(item)"
              >
                {{ item.label }}
              </li>
          </ul>
          <div class="layui-tab-content" style="height: calc(100% - 32px);">
            <slot />
          </div>
      </div>
  </div>
</template>

<script>
import request from '../../network/networkconfig'
export default {
  props: {
    msgNum: {
      type: Number
    },
    list: {
      type: Array,
      default: () => []
    }
  },
  methods: {
    loadTable(params) {
      params.active = !params.active;
      this.$emit('changeTabs', params.value);
    },
    readAll() {
        if(this.msgNum  == 0) {
          return;
        }
        let param = new FormData();
        let user = this.security.getUser();
        let userId = user.getUid();
        let userRole = user.getRoles().join(",");
        var type = '';
        if(userRole == 'kf'){
          type = 1;
        } else if(userRole == 'gcs'){
          type = 2;
        }  else {
          return;
        }
        request({
          url: '/msg/readAll/' + type,
          method: 'post',
          data: param
        }).then(response => {
          if (response.errorMsg) {
            console.error(response.errorMsg)
            this.layer.openAlert('错误提示：' + response.errorMsg)
          } else {
            this.$emit('readAll');
          }
        })
      },
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/common/pub-tabs.vue